/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceGroupMapRfidTagsRequest
 */
export interface DeviceGroupMapRfidTagsRequest {
    /**
     * List of RfidTagIds to be added to the group
     * @type {Array<number>}
     * @memberof DeviceGroupMapRfidTagsRequest
     */
    rfidTagsToAdd?: Array<number>;
    /**
     * List of RfidTagIds to be removed from the group
     * @type {Array<number>}
     * @memberof DeviceGroupMapRfidTagsRequest
     */
    rfidTagsToRemove?: Array<number>;
}

/**
 * Check if a given object implements the DeviceGroupMapRfidTagsRequest interface.
 */
export function instanceOfDeviceGroupMapRfidTagsRequest(
    value: object,
): value is DeviceGroupMapRfidTagsRequest {
    return true;
}

export function DeviceGroupMapRfidTagsRequestFromJSON(
    json: any,
): DeviceGroupMapRfidTagsRequest {
    return DeviceGroupMapRfidTagsRequestFromJSONTyped(json, false);
}

export function DeviceGroupMapRfidTagsRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceGroupMapRfidTagsRequest {
    if (json == null) {
        return json;
    }
    return {
        rfidTagsToAdd:
            json["rfidTagsToAdd"] == null ? undefined : json["rfidTagsToAdd"],
        rfidTagsToRemove:
            json["rfidTagsToRemove"] == null
                ? undefined
                : json["rfidTagsToRemove"],
    };
}

export function DeviceGroupMapRfidTagsRequestToJSON(
    value?: DeviceGroupMapRfidTagsRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        rfidTagsToAdd: value["rfidTagsToAdd"],
        rfidTagsToRemove: value["rfidTagsToRemove"],
    };
}
